// src/components/VerifiedHandleRow.tsx hardened/refactored v1

import { useState } from 'react';
import toast from 'react-hot-toast';
import { ConfirmModal } from './ConfirmModal';

interface VerifiedHandleRowProps {
  kind: string;
  value: string;
  isPrimary: boolean;
  onRemove: () => Promise<void>;
}

export function VerifiedHandleRow({ kind, value, isPrimary, onRemove }: VerifiedHandleRowProps) {
  const [showRemoveModal, setShowRemoveModal] = useState(false);
  const [isRemoving, setIsRemoving] = useState(false);

  const handleRemove = async () => {
    setIsRemoving(true);
    try {
      await onRemove();
      setShowRemoveModal(false);
    } catch (error) {
      void ['Remove error:', error];
      toast.error('Failed to remove contact point');
    } finally {
      setIsRemoving(false);
    }
  };

  return (
    <>
      <div className="flex items-center justify-between p-3 bg-transparent">
        <div className="flex items-center gap-2 min-w-0 flex-1">
          <span className="text-brand font-semibold flex-shrink-0">✓</span>
          <div className="min-w-0 flex-1">
            <div className="text-gray-900 flex flex-wrap items-center gap-2">
              <span
                className="break-all"
                style={{ fontFamily: "'Nunito', sans-serif", fontWeight: 600 }}
              >
                {value}
              </span>
              {isPrimary && (
                <span
                  className="inline-flex items-center px-2 py-0.5 rounded-full text-xs bg-none text-brand flex-shrink-0"
                  style={{ fontFamily: "'Nunito', sans-serif", fontWeight: 600 }}
                >
                  Primary
                </span>
              )}
            </div>
            <div
              className="text-xs text-gray-500 capitalize"
              style={{ fontFamily: "'Nunito', sans-serif", fontWeight: 600 }}
            >
              {kind}
            </div>
          </div>
        </div>
        
        {!isPrimary && (
          <button
            onClick={() => setShowRemoveModal(true)}
            className="text-xs text-red-600 hover:text-red-700 hover:underline flex-shrink-0 ml-2"
          >
            Remove
          </button>
        )}
      </div>

      <ConfirmModal
        isOpen={showRemoveModal}
        onClose={() => setShowRemoveModal(false)}
        onConfirm={handleRemove}
        title="Remove Contact Point?"
        message={`Are you sure you want to remove this ${kind}? This action cannot be undone.`}
        confirmText="Remove"
        confirmButtonClass="bg-red-600 hover:bg-red-700"
        isLoading={isRemoving}
      />
    </>
  );
}